// Not really a secret as it is exposed client side
export default 'daklawdjkcicw2474709wdui302';
